export default __webpack_public_path__ + "static/media/IMG-20241005-WA0055.2bb1384f.jpg";